import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import icons from '@ep/images/icons';
import theme from '@ep/theme';
import { SubNavItem } from '@ep/types/menuData';
import React from 'react';

export interface SubmenuLinkProps {
  subNavItem: SubNavItem;
}

const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem 0;
  text-align: initial;
  transition: ${theme.transitions.create(['color'])};

  > svg {
    width: 2.5rem;
    height: 2.5rem;
  }

  :hover {
    color: ${theme.colors.mediumBlue};
    text-decoration: none;
  }
`;

const Description = styled.span`
  font-size: ${theme.typography.toRem(16)};
  line-height: ${theme.typography.toRem(16)};
  @media (max-width: ${theme.breakpoints.navDrawerBreak}px) {
    font-size: 0.75rem;
  }
`;

const Label = styled(Description)`
  margin: 1rem 0 0.5rem;
  font-family: ${theme.typography.boldFont};
  font-weight: bold;
`;

function SubmenuLink({ subNavItem }: SubmenuLinkProps) {
  const Icon = icons[subNavItem.icon as keyof typeof icons];

  return (
    <StyledLink to={subNavItem.link}>
      <div>
        <Icon style={{ height: '2.5rem', width: '2.5rem' }} />
      </div>
      <Label>{subNavItem.label}</Label>
      <Description>{subNavItem.description}</Description>
    </StyledLink>
  );
}

export default React.memo(SubmenuLink);
